module.exports = __webpack_public_path__ + "ca6c2fba9fc579dcef2e43bd0d279fc1.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/guitar-acoustic-s.png
// module id = 1281
// module chunks = 0